import classNames from "classnames";
import { InfoIcon } from "../../AscIcons";
import AscGenericCard from "../AscGenericCard/AscGenericCard";
import styles from "./AscUserCard.module.scss";
import AscTooltip from "../../AscTooltip/AscTooltip";

export interface AscUserCardProps {
  name: string;
  imageUrl?: string;
}

export default function AscUserCard({ name, imageUrl }: AscUserCardProps) {
  return (
    <AscGenericCard
      className={classNames(styles.ground)}
      imageClassName={styles.cardImage}
      titleClassName={styles.cardTitle}
      bodyClassName={styles.cardBody}
      title={name}
      coverImageUrl={imageUrl}
    >
      <span className={styles.infoIconWrapper}>
        <AscTooltip
          place="right"
          tooltipAnchor={<InfoIcon className={styles.infoIcon} />}
        >
          Criteria. It is a long established fact that a reader will be
          distracted by the readable content of a page when looking at its
          layout.
        </AscTooltip>
      </span>
    </AscGenericCard>
  );
}
